"use client"

import Script from "next/script"

export default function Adoric() {
  return (
    <>
      <Script
        id="adoric-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
    (function (a, d, o, r, i, c, u, p, w, m) {
m = d.getElementsByTagName(o)[0], a[c] = a[c]
|| {}, a[c].trigger = a[c].trigger || function () {
(a[c].trigger.arg = a[c].trigger.arg || []).push(arguments)},
a[c].on = a[c].on || function () {(a[c].on.arg = a[c].on.arg || []).push(arguments)},
a[c].off = a[c].off || function () {(a[c].off.arg = a[c].off.arg || []).push(arguments)
}, w = d.createElement(o), w.id = i, w.src = r, w.async = 1, w.setAttribute(p, u),
m.parentNode.insertBefore(w, m), w = null}
)(window, document, "script", "https://55902259.adoric-om.com/adoric.js", "Adoric_Script", "adoric","e3ccbf47b99ee294d86a20c89a8e6480", "data-key");
  `,
        }}
      />
    </>
  )
}
